import { InjectionToken } from '@angular/core';
import { DiagnosticsEndpoint } from '@bindoc-projects/app-config-domain-lib';

export interface DiagnosticsRuntimeConfig {
  appId: string;
  environment?: string;
  endpoints: DiagnosticsEndpoint[];
}

export const DIAGNOSTICS_CONFIG = new InjectionToken<DiagnosticsRuntimeConfig>(
  'DIAGNOSTICS_CONFIG',
);
